import axios from "axios";

const api = axios.create({
  baseURL: "https://api.bi.playtelematics.com",
  // baseURL: "http://localhost:8080",
  timeout: 30000,
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("@USER_TOKEN");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
